/* ==========================================================
   PROGUS STORE LOCATOR - MOBILE GEOLOCATION FIX
   PERFORMANCE OPTIMIZED
   ========================================================== */

(function () {
  'use strict';

  const FRAME_SELECTOR =
    'iframe[src*="proguscommerce.com"], iframe[src*="progus.com"]';

  function fixFrame(frame) {
    if (!frame || !frame.matches?.(FRAME_SELECTOR)) return;

    const currentAllow = frame.getAttribute('allow') || '';

    if (!currentAllow.toLowerCase().includes('geolocation')) {
      frame.setAttribute(
        'allow',
        currentAllow
          ? currentAllow + '; geolocation'
          : 'geolocation'
      );

      if (!frame.dataset.progusGeoReloaded) {
        frame.dataset.progusGeoReloaded = 'true';

        const src = frame.getAttribute('src');
        if (src) frame.setAttribute('src', src);
      }
    }
  }

  function scan(root) {
    if (!root) return;

    if (root.nodeType === Node.ELEMENT_NODE &&
        root.matches?.(FRAME_SELECTOR)) {
      fixFrame(root);
    }

    root.querySelectorAll?.(FRAME_SELECTOR).forEach(fixFrame);
  }

  scan(document);

  const observer = new MutationObserver(mutations => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          scan(node);
        }
      });
    }
  });

  const root = document.querySelector('main') || document.documentElement;
  if (root) {
    observer.observe(root, {
      childList: true,
      subtree: true
    });
  }

  window.addEventListener('load', () => scan(document), { once: true });
})();

/* ============================================================
   AU NOIR — REMOVE STRAY COLON BEFORE PRICE

   Handles the initial product page plus dynamically inserted /
   replaced prices from Stretch, Quick Buy, linked products, filters,
   infinite scroll, and AJAX updates.

   Example fixed:
   <span class="sr-only">Selling price</span>: €94.95
   becomes:
   <span class="sr-only">Selling price</span>€94.95

   IMPORTANT:
   - Only removes a leading colon in the text node immediately after
     the sr-only accessibility label.
   - Does NOT edit currency symbols or price digits.
   ============================================================ */

(() => {
  'use strict';

  const PRICE_SELECTOR =
    'sale-price, compare-at-price';


  function cleanPriceElement(
    priceElement
  ) {

    if (!priceElement) {
      return;
    }


    const srOnly =
      priceElement.querySelector(
        ':scope > .sr-only'
      );


    if (!srOnly) {
      return;
    }


    let node =
      srOnly.nextSibling;


    while (
      node &&
      node.nodeType === Node.TEXT_NODE &&
      node.textContent.trim() === ''
    ) {
      node = node.nextSibling;
    }


    if (
      !node ||
      node.nodeType !== Node.TEXT_NODE
    ) {
      return;
    }


    const current =
      node.textContent;


    const cleaned =
      current.replace(
        /^\s*:\s*/,
        ''
      );


    if (cleaned !== current) {
      node.textContent = cleaned;
    }

  }


  function cleanPrices(
    root = document
  ) {

    if (
      root.nodeType === Node.ELEMENT_NODE &&
      root.matches?.(PRICE_SELECTOR)
    ) {
      cleanPriceElement(root);
    }


    root
      .querySelectorAll?.(PRICE_SELECTOR)
      .forEach(cleanPriceElement);

  }


  function initialClean() {
    cleanPrices(document);
  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initialClean,
      { once: true }
    );

  } else {

    initialClean();

  }


  const observer =
    new MutationObserver(
      mutations => {

        for (const mutation of mutations) {

          if (
            mutation.type === 'characterData'
          ) {

            const priceElement =
              mutation.target.parentElement
                ?.closest?.(PRICE_SELECTOR);


            if (priceElement) {
              cleanPriceElement(
                priceElement
              );
            }


            continue;
          }


          if (
            mutation.type === 'childList'
          ) {

            mutation.addedNodes.forEach(
              node => {

                if (
                  node.nodeType ===
                  Node.ELEMENT_NODE
                ) {

                  cleanPrices(node);

                }

              }
            );


            const targetPrice =
              mutation.target.nodeType ===
              Node.ELEMENT_NODE
                ? mutation.target.closest?.(
                    PRICE_SELECTOR
                  )
                : mutation.target.parentElement
                    ?.closest?.(
                      PRICE_SELECTOR
                    );


            if (targetPrice) {
              cleanPriceElement(
                targetPrice
              );
            }

          }

        }

      }
    );


  const startObserver = () => {

    if (!document.documentElement) {
      return;
    }


    observer.observe(
      document.documentElement,
      {
        childList: true,
        subtree: true,
        characterData: true
      }
    );

  };


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      startObserver,
      { once: true }
    );

  } else {

    startObserver();

  }

})();

/* ============================================================
   AU NOIR — FIRST COLLECTION PRODUCT MOBILE SWIPE HINT
   SMOOTH / AFTER FULL PAGE LOAD

   - Mobile only
   - Collection pages only
   - First collection product only
   - Waits until page + first 2 images are fully loaded
   ============================================================ */

(() => {
  'use strict';

  const MOBILE_QUERY = '(max-width: 699px)';

  if (!window.matchMedia(MOBILE_QUERY).matches) return;

  if (
    !window.location.pathname.includes('/collections/') ||
    window.location.pathname.includes('/products/')
  ) {
    return;
  }

  if (window.auNoirFirstProductSwipeHint) return;
  window.auNoirFirstProductSwipeHint = true;


  /* ============================================================
     SMOOTH SCROLL ANIMATION
     ============================================================ */

  function animateScroll(
    gallery,
    from,
    to,
    duration,
    callback
  ) {

    const startTime = performance.now();

    function ease(t) {

      /*
        Smooth ease-in-out
      */

      return t < 0.5
        ? 4 * t * t * t
        : 1 - Math.pow(-2 * t + 2, 3) / 2;
    }

    function frame(now) {

      const progress = Math.min(
        (now - startTime) / duration,
        1
      );

      const eased = ease(progress);

      gallery.scrollLeft =
        from +
        ((to - from) * eased);

      if (progress < 1) {

        requestAnimationFrame(frame);

      } else {

        gallery.scrollLeft = to;

        if (callback) callback();

      }

    }

    requestAnimationFrame(frame);
  }


  /* ============================================================
     WAIT FOR IMAGE
     ============================================================ */

  async function waitForImage(img) {

    if (!img) return;

    /*
      Force first product's second image to load.
      Only affects this one product.
    */

    img.loading = 'eager';

    if (!img.complete) {

      await new Promise(resolve => {

        const finish = () => resolve();

        img.addEventListener(
          'load',
          finish,
          { once: true }
        );

        img.addEventListener(
          'error',
          finish,
          { once: true }
        );

      });

    }

    /*
      Wait until browser has actually decoded
      the image before starting animation.
    */

    if (typeof img.decode === 'function') {

      try {

        await img.decode();

      } catch (_) {}

    }

  }


  /* ============================================================
     RUN SWIPE HINT
     ============================================================ */

  async function runHint(gallery) {

    if (!gallery) return;

    if (
      gallery.dataset.auSwipeHintDone === 'true'
    ) {
      return;
    }

    const images =
      gallery.querySelectorAll(
        '.product-card__gallery-image'
      );

    if (images.length < 2) return;


    /* ----------------------------------------------------------
       WAIT FOR IMAGE #1 + IMAGE #2
       ---------------------------------------------------------- */

    await Promise.all([
      waitForImage(images[0]),
      waitForImage(images[1])
    ]);


    /*
      Give browser two complete paint cycles
      after decoding.
    */

    await new Promise(resolve => {

      requestAnimationFrame(() => {

        requestAnimationFrame(resolve);

      });

    });


    if (
      gallery.clientWidth < 50 ||
      gallery.scrollWidth <=
        gallery.clientWidth + 20
    ) {
      return;
    }


    gallery.dataset.auSwipeHintDone = 'true';


    /* ==========================================================
       TEMPORARILY DISABLE SNAP
       ========================================================== */

    const oldSnap =
      gallery.style.getPropertyValue(
        'scroll-snap-type'
      );

    const oldSnapPriority =
      gallery.style.getPropertyPriority(
        'scroll-snap-type'
      );

    const oldBehavior =
      gallery.style.getPropertyValue(
        'scroll-behavior'
      );

    const oldBehaviorPriority =
      gallery.style.getPropertyPriority(
        'scroll-behavior'
      );


    gallery.style.setProperty(
      'scroll-snap-type',
      'none',
      'important'
    );

    gallery.style.setProperty(
      'scroll-behavior',
      'auto',
      'important'
    );


    gallery.scrollLeft = 0;


    /* ==========================================================
       DISTANCE
       ========================================================== */

    const distance = Math.min(
      75,
      Math.max(
        55,
        gallery.clientWidth * 0.18
      )
    );


    /*
      Small delay after everything is completely ready.
    */

    await new Promise(
      resolve =>
        setTimeout(resolve, 500)
    );


    /* ==========================================================
       MOVE TOWARD IMAGE 2
       ========================================================== */

    animateScroll(
      gallery,
      0,
      distance,
      500,

      () => {

        /*
          Let customer see the second photo slightly.
        */

        setTimeout(() => {


          /* ====================================================
             RETURN TO IMAGE 1
             ==================================================== */

          animateScroll(
            gallery,
            distance,
            0,
            600,

            () => {

              gallery.scrollLeft = 0;


              /* ================================================
                 RESTORE NORMAL CAROUSEL
                 ================================================ */

              if (oldSnap) {

                gallery.style.setProperty(
                  'scroll-snap-type',
                  oldSnap,
                  oldSnapPriority
                );

              } else {

                gallery.style.removeProperty(
                  'scroll-snap-type'
                );

              }


              if (oldBehavior) {

                gallery.style.setProperty(
                  'scroll-behavior',
                  oldBehavior,
                  oldBehaviorPriority
                );

              } else {

                gallery.style.removeProperty(
                  'scroll-behavior'
                );

              }

            }
          );

        }, 250);

      }
    );

  }


  /* ============================================================
     FIND FIRST REAL COLLECTION PRODUCT
     ============================================================ */

  function initialize() {

    const productList =
      document.querySelector(
        'main .product-list'
      ) ||
      document.querySelector(
        '.product-list'
      );

    if (!productList) return;


    const firstCard =
      productList.querySelector(
        'product-card'
      );

    if (!firstCard) return;


    const gallery =
      firstCard.querySelector(
        '.product-card__media--gallery'
      );

    if (!gallery) return;


    /* ==========================================================
       WAIT UNTIL PRODUCT IS ACTUALLY VISIBLE
       ========================================================== */

    const observer =
      new IntersectionObserver(
        entries => {

          const entry = entries[0];

          if (!entry.isIntersecting) return;

          observer.disconnect();

          runHint(gallery);

        },
        {
          threshold: 0.4
        }
      );


    observer.observe(gallery);

  }


  /* ============================================================
     WAIT UNTIL EVERYTHING ON PAGE IS LOADED
     ============================================================ */

  function startAfterFullLoad() {

    /*
      Extra delay gives Shopify / apps /
      swatches / layout time to settle.
    */

    setTimeout(() => {

      requestAnimationFrame(() => {

        requestAnimationFrame(() => {

          initialize();

        });

      });

    }, 700);

  }


  if (document.readyState === 'complete') {

    startAfterFullLoad();

  } else {

    window.addEventListener(
      'load',
      startAfterFullLoad,
      { once: true }
    );

  }

})();

/* =========================================================
   AU NOIR — MOBILE FILTER GLASS BUTTON
   PERFORMANCE OPTIMIZED / SINGLE COPY
   ========================================================= */

(function () {
  'use strict';

  const MOBILE_QUERY = '(max-width: 699px)';
  const path = window.location.pathname;

  if (!window.matchMedia(MOBILE_QUERY).matches) return;
  if (!path.includes('/collections/') || path.includes('/products/')) return;


  function considerElement(el) {
    if (!el || !el.matches?.('button, a, [role="button"], summary')) {
      return;
    }

    if (el.classList.contains('au-mobile-filter-glass')) return;

    const text = (el.textContent || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();

    const isFilterButton =
      text.includes('filter and sort') ||
      text.includes('filtrer et trier');

    if (!isFilterButton) return;

    // Only now do a layout read. We no longer measure every button/link.
    const rect = el.getBoundingClientRect();

    if (rect.width > 180 && rect.height < 100) {
      el.classList.add('au-mobile-filter-glass');
      el.parentElement?.classList.add(
        'au-mobile-filter-glass-wrapper'
      );
    }
  }


  function styleWithin(root) {
    if (!root) return;

    if (root.nodeType === Node.ELEMENT_NODE) {
      considerElement(root);
    }

    root.querySelectorAll?.(
      'button, a, [role="button"], summary'
    ).forEach(considerElement);
  }


  function initialStyle() {
    styleWithin(document.querySelector('main') || document);
  }


  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialStyle,
      { once: true }
    );
  } else {
    initialStyle();
  }


  const startObserver = () => {
    const root = document.querySelector('main');
    if (!root) return;

    const observer = new MutationObserver(mutations => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            styleWithin(node);
          }
        });
      }
    });

    observer.observe(root, {
      childList: true,
      subtree: true
    });
  };


  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      startObserver,
      { once: true }
    );
  } else {
    startObserver();
  }

})();

/* =========================================================
   AU NOIR — GLASS DRAWERS + QUICK VIEW
   Stretch Theme / Shadow DOM
   Mobile + Desktop — PERFORMANCE OPTIMIZED
   ========================================================= */

(function () {
  'use strict';

  const SHADOW_STYLE_ID = 'au-noir-glass-drawer-shadow';

  const DRAWER_SELECTOR = [
    'x-drawer',
    'cart-drawer',
    'search-drawer',
    'facet-drawer',
    'facets-drawer',
    'header-drawer',
    'quick-buy-modal',
    'quick-view-modal',
    '[id*="quick-buy"]',
    '[id*="quick-view"]',
    '[class*="quick-buy-modal"]',
    '[class*="quick-view-modal"]',
    '[id*="drawer"]',
    '[class~="drawer"]'
  ].join(',');

  const shadowCSS = `
    :host {
      --au-glass-bg: rgba(18, 18, 20, 0.74);
    }

    header,
    footer,
    .drawer__header,
    .drawer__footer,
    .dialog__header,
    .dialog__footer,
    .modal__header,
    .modal__footer,
    [part="header"],
    [part="footer"],
    [class*="drawer-header"],
    [class*="drawer-footer"],
    [class*="drawer__header"],
    [class*="drawer__footer"],
    [class*="modal-header"],
    [class*="modal-footer"],
    [class*="modal__header"],
    [class*="modal__footer"] {
      background: transparent !important;
      background-color: transparent !important;
      box-shadow: none !important;
    }

    header,
    .drawer__header,
    .dialog__header,
    .modal__header,
    [part="header"] {
      border-bottom: 1px solid rgba(255,255,255,0.09) !important;
    }

    footer,
    .drawer__footer,
    .dialog__footer,
    .modal__footer,
    [part="footer"] {
      border-top: 1px solid rgba(255,255,255,0.09) !important;
    }

    [part="content"],
    .drawer__content,
    .dialog__content,
    .modal__content,
    .quick-buy-modal__content,
    .quick-view-modal__content {
      background: rgba(18,18,20,0.74) !important;
      background-color: rgba(18,18,20,0.74) !important;
      -webkit-backdrop-filter: blur(28px) saturate(180%) !important;
      backdrop-filter: blur(28px) saturate(180%) !important;
    }

    .quick-buy-modal__inner,
    .quick-buy-modal__content,
    .quick-buy-modal__product,
    .quick-view-modal__inner,
    .quick-view-modal__content,
    .quick-view-modal__product,
    .product-info,
    .product-info__block-list,
    .product-info__block-item,
    .product-info__buy-buttons,
    .product,
    .product__info,
    .product__info-container {
      background: transparent !important;
      background-color: transparent !important;
    }

    .product-gallery,
    .product-gallery__media,
    .product-gallery__media-list,
    .product-gallery__carousel,
    .product-media-container {
      background: transparent !important;
      background-color: transparent !important;
    }

    button[aria-label*="Close"],
    button[aria-label*="close"],
    button[aria-label*="Fermer"],
    button[aria-label*="fermer"],
    .drawer__close,
    .dialog__close,
    .modal__close,
    [class*="close-button"] {
      background: rgba(255,255,255,0.08) !important;
      border: 1px solid rgba(255,255,255,0.10) !important;
      border-radius: 999px !important;
      -webkit-backdrop-filter: blur(14px) !important;
      backdrop-filter: blur(14px) !important;
    }
  `;


  function injectIntoShadowRoot(element) {
    if (!element?.shadowRoot) return false;

    if (element.shadowRoot.querySelector('#' + SHADOW_STYLE_ID)) {
      return true;
    }

    const style = document.createElement('style');
    style.id = SHADOW_STYLE_ID;
    style.textContent = shadowCSS;
    element.shadowRoot.appendChild(style);
    return true;
  }


  function scanRoot(root) {
    if (!root) return false;

    let found = false;

    if (root.nodeType === Node.ELEMENT_NODE &&
        root.matches?.(DRAWER_SELECTOR)) {
      found = true;
      injectIntoShadowRoot(root);
    }

    const descendants = root.querySelectorAll?.(DRAWER_SELECTOR);

    if (descendants?.length) {
      found = true;
      descendants.forEach(injectIntoShadowRoot);
    }

    return found;
  }


  function retryTarget(root) {
    // Do not create retry timers for ordinary product/image/text insertions.
    // Retry only when the inserted subtree actually contains a drawer/modal.
    const found = scanRoot(root);
    if (!found) return;

    // Custom elements may attach their shadowRoot just after insertion.
    setTimeout(() => scanRoot(root), 60);
    setTimeout(() => scanRoot(root), 250);
  }


  function initialScan() {
    scanRoot(document);
  }


  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialScan,
      { once: true }
    );
  } else {
    initialScan();
  }


  // One small post-load pass for Stretch components upgraded late.
  window.addEventListener(
    'load',
    () => setTimeout(initialScan, 250),
    { once: true }
  );


  const observer = new MutationObserver(mutations => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          retryTarget(node);
        }
      });
    }
  });


  const startObserver = () => {
    const root = document.body || document.documentElement;
    if (!root) return;

    observer.observe(root, {
      childList: true,
      subtree: true
    });
  };


  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      startObserver,
      { once: true }
    );
  } else {
    startObserver();
  }


  document.addEventListener(
    'dialog:after-show',
    event => retryTarget(event.target || document),
    true
  );


  document.addEventListener(
    'click',
    event => {
      const trigger = event.target.closest?.(
        '[aria-controls*="quick-buy"],' +
        '[aria-controls*="quick-view"],' +
        '.product-card__quick-add-button'
      );

      if (!trigger) return;

      const id = trigger.getAttribute('aria-controls');
      const target = id ? document.getElementById(id) : null;

      if (target) {
        retryTarget(target);
      }
    },
    true
  );

})();

